var _path, _path2, _path3, _path4, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 281,
    viewBox: "0 0 342 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.749 179.337L42.5732 179.337C40.5969 179.337 38.806 180.502 38.0037 182.308L3.12258 260.834C1.65392 264.14 4.07423 267.864 7.69208 267.864L334.086 267.864C337.76 267.864 340.179 264.035 338.602 260.717L301.264 182.19C300.436 180.448 298.678 179.337 296.749 179.337Z",
    fill: "#636060",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.164 218.306L48.6659 196.482C50.3321 193.02 53.8346 190.819 57.6768 190.819H283.218C287.023 190.819 290.498 192.978 292.183 196.389L302.967 218.212C306.251 224.858 301.415 232.642 294.001 232.642H47.1749C39.807 232.642 34.969 224.945 38.164 218.306Z",
    fill: "#A29F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 263H339L334.034 276.428C333.018 279.176 330.398 281 327.469 281H15.0077C12.1565 281 9.5901 279.271 8.51971 276.628L3 263Z",
    fill: "#323030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.917 241.706C152.148 240.249 153.405 239.177 154.88 239.177H186.597C188.037 239.177 189.274 240.2 189.543 241.615L192.014 254.566C192.367 256.415 190.95 258.128 189.067 258.128H152.821C150.976 258.128 149.568 256.479 149.858 254.657L151.917 241.706Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 0.5,
    width: 256,
    height: 178,
    rx: 9.5,
    fill: "#636060",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 12.5,
    width: 230,
    height: 154,
    rx: 9.5,
    fill: "black",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.e671339befa38c8912edf928536f9594.svg";
export { ForwardRef as ReactComponent };